import type { ColorScheme } from '@pesto/utils/src/style/colorSchemeHelper';

export const colorSchemes = {
  default: {
    '--primary': '140 56% 41%',
    '--accent': '140 56% 41%',
    '--accent-foreground': '160 75% 13%',
  },
  blue: {
    '--primary': '200 80% 50%',
    '--accent': '180 70% 60%',
  },
  pink: {
    '--primary': '330 80% 50%',
    '--accent': '310 70% 60%',
  },
  green: {
    '--primary': '140 56% 41%',
    '--accent': '140 56% 41%',
    '--accent-foreground': '160 75% 13%',
  },
  orange: {
    '--primary': '30 80% 50%',
    '--accent': '20 70% 60%',
  },
} satisfies Record<string, ColorScheme>;
